'use client'

import type { ReactElement } from 'react'

import { SlideCarousel } from '@/components/carousel/SlideCarousel'

/**
 * The promotions carousel in the article sidebar, rendered twice per article
 * page (mobile `d-block d-lg-none` and desktop `d-none d-lg-block`).
 *
 * Both instances previously shared a single `carouselRef` — two live carousels
 * writing one ref, so the second mount silently clobbered the first. Nothing
 * ever read `.current`, so the ref is gone rather than duplicated.
 *
 * Uncontrolled: nothing outside reads or drives the index, so no index prop.
 */
export function PromotionCarousel({ children }: { children: ReactElement[] }) {
  return (
    <SlideCarousel autoPlay loop interval={3000} className="article-promo-carousel">
      {children}
    </SlideCarousel>
  )
}
